import InstructorFirstVisitConversionsModule from "./InstructorFirstVisitConversions";
import Saga from "../common/saga";
import { createReducer } from "../common/createReducer";

export default {
  Component: InstructorFirstVisitConversionsModule,
  moduleName: "firstVisitConversions",
  saga: Saga("firstVisitConversions"),
  reducer: createReducer("firstVisitConversions")
};
